import { graphql } from "gql";

const ADMIN_CREATE_TAG_CATEGORY_MUTATION = graphql(`
  mutation AdminCreateTagCategory($input: AdminCreateTagCategoryInput!) {
    adminCreateTagCategory(input: $input) {
      ...TagCategory
    }
  }
`);

export default ADMIN_CREATE_TAG_CATEGORY_MUTATION;
